module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_4@3x.187571ee.png";